import { useFeatureFlags } from '@usap/core'
import { parseOptimizelyDecisionsCookie } from '../helpers/cookieHelper';
import { useCookies } from 'react-cookie';

const useSocialLoginEnabled = () => {
  const { f38 } = useFeatureFlags()
  const [cookies] = useCookies(["opt_dec"])

  const f38Enabled = ['b', '1', 'on', 'true']

  if(typeof f38 === 'string') {
    if(f38Enabled.includes(f38)) {
      return true
    }
    return false
  }

  // NOTE: Temperory solution
  // TODO: Check why on first load of login page f38 value is false
  if(typeof f38 === 'boolean') {
    if(typeof window !== 'undefined') {
      const cookieObject = parseOptimizelyDecisionsCookie(cookies?.opt_dec)
      const variation = cookieObject.f38;
     
      if(f38Enabled.includes(variation)) {
        return true
      }
      return false
    }
  }

  return false
}

export default useSocialLoginEnabled
